import { delay, toRelativeUrl } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { USER_LOGIN } from "../../constants/Constants";
import LoginComponent from "../../pages/login/LoginComponent";
import { getUserLoggedOutStatus, setAuthToken, setUserEmailId, setUserLoggedOut, setUserName } from "../../store/OktaAuthSlice";
import { useAppDispatch } from "../../store/store";

export const RequiredAuth = () => {

  const { oktaAuth, authState } = useOktaAuth();

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const location = useLocation();

  const isLoggedOut = useSelector(getUserLoggedOutStatus);

  useEffect(() => {

    if (!authState) {
      return;
    }

    if (!authState?.isAuthenticated) {
      localStorage.clear();
      oktaAuth.tokenManager.clear();
      if (isLoggedOut) {
        console.log("Inside")
        delay(2000).then(res => {
          navigate(USER_LOGIN);
        })
      } else {
        const originalUri = toRelativeUrl(
          window.location.href,
          window.location.origin
        );
        oktaAuth.setOriginalUri(originalUri);
      }
    } else {
      delay(5000).then(res => {
        dispatch(setUserLoggedOut(false));
      });
      if (authState?.accessToken?.accessToken)
        dispatch(setAuthToken(authState.accessToken.accessToken));

      if (authState?.idToken?.claims.name)
        dispatch(setUserName(authState.idToken.claims.name));

      if (authState?.idToken?.claims.email)
        dispatch(setUserEmailId(authState.idToken.claims.email));

    }


  }, [oktaAuth, !!authState, authState?.isAuthenticated]);


  if ((location?.pathname === "" || location?.pathname === "/")) {
    return <LoginComponent />
  }
  return <Outlet />
};